<template>
  <div id="list-transaction">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title> Filtres </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form @submit.prevent="updateSearchTerm">
              <v-row align="center">
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    label="Email"
                    v-model="datatableProxyFilters.email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    label="Num CB"
                    v-model="datatableProxyFilters.numCb"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    label="Transaction ID"
                    v-model="datatableProxyFilters.transactionId"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    label="Client ID"
                    v-model="datatableProxyFilters.clientId"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    label="Num Fac."
                    v-model="datatableProxyFilters.bill"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-menu
                    ref="dateMenuRef"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeText"
                        label="Picker in menu"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      range
                      v-model="datatableProxyFilters.dateRange"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dateMenu = false">
                        Annuler
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          dateMenuRef.save(datatableProxyFilters.dateRange)
                        "
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-btn type="submit" class="white--text" color="#2c3e50"
                    >Filtrer</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <div id="table-cbs-container">
              <cb-transaction-datatable
                :filterParams="filterParams"
              ></cb-transaction-datatable>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { useTitle } from "@/composables/title";
import CbTransactionDatatable from "@/components/Group/CbTransactionDatatable";
import { computed, reactive, ref } from "@vue/composition-api";

export default {
  components: { CbTransactionDatatable },
  setup() {
    const { setTitle } = useTitle();
    setTitle("Liste des transactions CB");

    const dateRangeText = computed(() => {
      if (datatableProxyFilters.dateRange != null) {
        return datatableProxyFilters.dateRange.join(" ~ ");
      }
      return null;
    });

    const filterParams = reactive({
      email: "",
      numCb: "",
      clientId: "",
      dateRange: [],
      transactionId: "",
      bill: "",
    });

    const datatableProxyFilters = reactive({
      email: "",
      numCb: "",
      clientId: "",
      dateRange: [],
      transactionId: "",
      bill: "",
    });

    const updateSearchTerm = () => {
      Object.assign(filterParams, datatableProxyFilters);
    };

    return {
      dateMenuRef: ref(null),
      dateMenu: ref(null),
      dateRangeText,
      datatableProxyFilters,
      updateSearchTerm,
      filterParams,
    };
  },
};
</script>
